import React from "react";
import styled from "styled-components";
import colors from "../../assets/colors";

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ text, subText, url }) {
  return (
    <div className="main-container">
      <div>
        <div>
          <img style={{ height: "150px" }} src={url} alt="" />
        </div>
      </div>
      <h3 style={{ margin: "10px 0", color: colors.black }}>{text}</h3>
      <p
        style={{
          padding: "10px 45px",
          fontWeight: "600",
          color: colors.grey,
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        {subText}
      </p>
      <Link href="https://www.etapinsure.com">Learn more</Link>
    </div>
  );
}

const Link = styled("a")`
  text-decoration: none;
  background-color: #02d7f2;
  color: ${colors.black};
  padding: 15px 25px;
  font-weight: bold;
  border-radius: 8px;
  margin-top: 10px;
  font-size: 15px;
`;
